export default __webpack_public_path__ + "static/media/151-line-chart.beeb0a0b.png";